var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverShiftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 66,
    height: 65,
    transform: "translate(2 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_241_3",
    "data-name": "Component 241 \\u2013 3",
    transform: "translate(7.459 12.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M6936.077,6964.18c.8.114.923,1.3.9,2.2a8.97,8.97,0,0,1-2.458,5.433,10.023,10.023,0,0,1-2.07,4.075,20.458,20.458,0,0,0,4.2,2.2,13.6,13.6,0,0,0-2.263,8.539,15.379,15.379,0,0,0,2.976,7.762,87.484,87.484,0,0,1-27.1-1.164c-1.071-.23-2.5-.631-2.781-1.423-.331-.934.146-2.48.323-3.3.633-2.889,2-5.823,3.947-7.246a27.274,27.274,0,0,1,5.5-2.587,42.05,42.05,0,0,0,5.369-2.716c-.33-.566-.778-1.078-1.165-1.811-.36-.683-.51-1.451-.84-2.2a10.6,10.6,0,0,0-1.1-1.423,8.434,8.434,0,0,1-.841-1.681c-.444-1.139-1.005-2.808-.324-4.076a.745.745,0,0,1,.647-.518c.074-1.619-.027-3.046.065-4.334.293-4.094,3.187-6.748,7.31-7.051,5.4-.4,9.262,2.042,9.638,6.921C6936.112,6961.085,6936.029,6962.542,6936.077,6964.18Z",
    transform: "translate(-6907.371 -6952.816)",
    fill: "#878787",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(16.251 12.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M7228.723,7179.667a12.372,12.372,0,0,1,12.93,12.061,12.375,12.375,0,0,1-12.06,12.931,12.8,12.8,0,0,1-9.112-3.417,11.911,11.911,0,0,1-3.819-8.644,12.1,12.1,0,0,1,6.968-11.659A12.782,12.782,0,0,1,7228.723,7179.667Zm-1.609,10.519c.229-.244.752-.392.87-.737a13.2,13.2,0,0,0,0-2.949,11.338,11.338,0,0,0-.066-2.88,1.633,1.633,0,0,0-1.941-.871,10.034,10.034,0,0,0-6.7,8.576c-.08,1.211-.117,2.786.469,3.485,1.133,1.349,2.928-.3,3.954-.871.976-.549,1.81-1.038,2.679-1.542A2.757,2.757,0,0,1,7227.113,7190.185Zm7.5,3.753c.794.445,1.837,1.426,2.814,1.407,1.686-.03,1.723-2.493,1.605-4.087a9.63,9.63,0,0,0-2.277-5.5c-1.222-1.455-3.229-2.936-4.757-3.082-2.757-.265-1.315,4.355-1.673,6.834a3,3,0,0,1,1.606,2.881C7232.814,7192.9,7233.635,7193.386,7234.618,7193.938Zm-5.429-.6c1.582-.037,1.483-2.8-.4-2.278A1.174,1.174,0,0,0,7229.189,7193.335Zm-1.607,1.138c-.724.336-1.72.9-2.948,1.609-.841.48-2.223,1.034-2.48,1.807-.542,1.638,1.534,2.572,2.547,3.082a10.254,10.254,0,0,0,8.912,0c1.019-.513,2.543-1.327,2.611-2.411.092-1.428-1.706-2.022-2.746-2.613-1.016-.578-1.906-1.01-2.747-1.542A2.778,2.778,0,0,1,7227.582,7194.473Z",
    transform: "translate(-7204.225 -7172.354)",
    fill: "#4d4d4f",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverShiftIcon);
export default __webpack_public_path__ + "static/media/driver_shift_icon.d613c54fbf1db806efa35bc0bd82d47b.svg";
export { ForwardRef as ReactComponent };